// src/components/Carousel.tsx
import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const slides = [
    {
        image: "/carousel/slide1.jpg",
        subtitle: "Your trusted partner for precision design, milling, and 3D printing",
        title:
            "With the help of advanced machines from Yenadent and Roland, along with optimized strategies, we achieve the highest milling quality.",
    },
    {
        image: "/carousel/slide2.jpg",
        subtitle: "Precision Dental Milling & 3D Printing",
        title:
            "Expert design, fast dispatch, and cutting-edge technology for your lab needs.",
    },
    {
        image: "/carousel/slide3.jpg",
        subtitle: "Tomorrow’s Smiles, Milled Today",
        title:
            "High-quality dental design, milling, and 3D printing with next-day turnaround.",
    },
];

const Carousel = () => {
    const [current, setCurrent] = useState(0);
    const length = slides.length;

    const nextSlide = () => {
        setCurrent((prev) => (prev === length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrent((prev) => (prev === 0 ? length - 1 : prev - 1));
    };

    useEffect(() => {
        const timer = setInterval(nextSlide, 5000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="relative flex justify-center py-8 px-4">
            <div
                className="relative w-full max-w-5xl h-[300px] sm:h-[400px] md:h-[450px] overflow-hidden rounded-xl shadow-xl group
                   transition-shadow duration-500
                   hover:shadow-[0_0_30px_5px_rgba(2,89,81,0.5)]"
            >
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`absolute inset-0 transition-opacity duration-1000 ease-in-out rounded-xl overflow-hidden ${index === current ? "opacity-100 z-10" : "opacity-0 z-0"
                            }`}
                    >
                        <img
                            src={slide.image}
                            alt={`Slide ${index + 1}`}
                            className="w-full h-full object-cover brightness-30 transition-transform duration-500 group-hover:scale-[1.01]"
                        />

                        {/* Overlay negru semi-transparent */}
                        <div className="absolute inset-0 bg-black bg-opacity-70 rounded-xl pointer-events-none"></div>

                        {/* Text cu padding lateral mai mare */}
                        <div className="absolute inset-0 flex flex-col items-center justify-center px-16 sm:px-24 text-center">
                            <h3
                                className="text-[#71c9c0] text-base sm:text-lg md:text-xl font-semibold uppercase underline mb-3 max-w-3xl"
                                style={{ letterSpacing: "0.05em" }}
                            >
                                {slide.subtitle}
                            </h3>

                            <h2 className="text-white text-lg sm:text-2xl md:text-3xl font-serif font-bold max-w-4xl leading-snug">
                                {slide.title}
                            </h2>
                        </div>
                    </div>
                ))}


                {/* Săgeți pe imagine, în interior */}
                <button
                    onClick={prevSlide}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/40 text-white p-2 rounded-full hover:bg-[#025951]/70 hover:shadow-lg transition z-30"
                >
                    <ChevronLeft size={30} />
                </button>
                <button
                    onClick={nextSlide}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/40 text-white p-2 rounded-full hover:bg-[#025951]/70 hover:shadow-lg transition z-30"
                >
                    <ChevronRight size={30} />
                </button>

                {/* Puncte indicator */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
                    {slides.map((_, index) => (
                        <span
                            key={index}
                            onClick={() => setCurrent(index)}
                            className={`w-3 h-3 rounded-full cursor-pointer transition border border-white ${index === current ? "bg-white" : "bg-white/40"
                                }`}
                        ></span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Carousel;
